import { Project } from "./@types/projects"

const projects: Project[] = [
  {
    name: "Oxira",
    description:
      "MCP server for evaluating startup ideas: market research, competitor analysis, and pricing extraction. Published to npm.",
    stack: ["TypeScript", "MCP SDK", "Zod", "Node.js"],
    sourceCode: "https://github.com/evank21/oxira",
    livePreview: "",
  },
  {
    name: "Nova",
    description:
      "Personal CRM that tracks relationship health, surfaces overdue contacts as a daily briefing, and sends SMS nudges via Twilio.",
    stack: ["React", "TypeScript", "Hono", "Drizzle ORM", "PostgreSQL"],
    sourceCode: "https://github.com/evank21/nova",
    livePreview: "",
  },
  {
    name: "Drop Club",
    description:
      "React Native social app with a gamified weekly competitive layer, scoring engine, leaderboard, and push notifications via Supabase Edge Functions.",
    stack: ["React Native", "Expo", "Supabase", "TypeScript"],
    sourceCode: "https://github.com/evank21/drop-club",
    livePreview: "",
  },
]

const skills = [
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "React",
  "GraphQL",
  "Git",
  "Netlify",
  "Jest",
  "Apollo",
]

export { projects, skills }
